import { createFileRoute, redirect } from '@tanstack/react-router'

// Màn "Cân chè thành phẩm" cũ — đã thay bằng màn Cân chè khô
// (/dried-tea-purchases). Giữ route để bookmark cũ không gãy.
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/tea-purchases/processing',
)({
    beforeLoad: () => {
        throw redirect({ to: '/dried-tea-purchases' })
    },
})
